import { jsxs as o, jsx as n } from "react/jsx-runtime";
import { memo as s } from "react";
import { u as e } from "../../../../styled-components.browser.esm-BFmoFexH.js";
const m = s(({
  prefix: t,
  suffix: i,
  children: r
}) => /* @__PURE__ */ o(f, { children: [
  t && /* @__PURE__ */ n(l, { children: t }),
  r,
  i && /* @__PURE__ */ n(p, { children: i })
] })), f = e.div`
  display: flex;
  gap: 6px;
`, l = e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 7px;
`, p = e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-left: 7px;
`;
export {
  m as default
};
//# sourceMappingURL=SuffixPrefixWrapper.js.map
